export const API = {
  POST: {
    LIST: {
      // TODO Attività Internazionali: endpoint placeholder, non ancora disponibili lato backend.
      // Attualmente i dati sono serviti dal service fittizio components/attivita-internazionali/fakeApi.ts.
      PAGAMENTI_QUOTE_STANDARD:"v1/Tornei/GestioneGare/quoteChiusuraStandard",
      ATTIVITA_INTERNAZIONALI: "/v1/AttivitaInternazionali/AttivitaInternazionali/list",
      ATTIVITA_INTERNAZIONALI_DELETE: "/v1/AttivitaInternazionali/AttivitaInternazionali/delete",
      REPORT_SQUADRE_CIRCOLO: "/v1/Report/SquadreCircolo/list",
      GIOCATORI_INCONTRO:"/v1/Campionati/GiocatoriIncontro/list",
      MANIFESTAZIONI_GARE_PARTITE:"/v1/Manifestazioni/Partite/list",
      MANIFESTAZIONI_GARE:"/v1/Manifestazioni/Gare/list",
      MANIFESTAZIONI:"/v1/Manifestazioni/Manifestazioni/list",
      BACKOFFICE_COMUNI: "/v1/Backoffice/Comuni/list",
      CAMPIONATI_PARITTE_FORMATTED: "/v1/Campionati/GestioneIncontriTabellone/formattedList",
      PARTITE_INCONTRI: "/v1/Campionati/PartiteIncontri/list",
      LOOKUP_TIPOLOGIE_COMPETIZIONI: "/v1/Lookup/tipologie_competizione/list",
      QUOTE_GARA_TORNEO: "/v1/Tornei/GestioneGare/quoteList",
      TABELLONE_PARTITE_FORTMATTED: "/v1/Tornei/GestionePartiteGara/formattedList",
      TIPI_CAMPI: "/v1/Backoffice/TipiCampi/list",
      MODALITA_AGGIUNTA_GIOCATORI_GARA_A_SQUADRE: "/v1/Lookup/ModalitaGaraASquadreAggiuntaGiocatori/list",
      UFFICIALI_ASSISTENTI: "/v1/Tornei/UfficialiDiGaraAssistenti/list",
      TIPOLOGIA_GARE_A_QUADRE_QUOTE_GARE_A_SQUADRE: "/v1/Lookup/TipologiaGaraASquadreQuotaGareASquadre/list",
      CATEGORIE_ETA_GARA_A_SQUADRE: "/v1/Lookup/TipologiaGaraASquadreCategoriaEta/list",
      CATEGORIE_CLASSIFICA_GARA_A_SQUADRE: "/v1/Lookup/TipologiaGaraASquadreCategoriaClassifica/list",
      SERIE_GARA_A_SQUADRE: "/v1/Lookup/TipologiaGaraASquadreSerieGaraASquadre/list",
      TIPOLOGIA_ORARIO: "/v1/Lookup/TipologiaOrarioPartitaGara/list",
      ODG_CAMPI: "v1/Tornei/CampiOrariDiGioco/list",
      ODG_SHEETS: "v1/Tornei/SheetOrariDiGioco/list",
      CAMPIONATI: "/v1/Campionati/Campionati/list",
      CAMPIONATI_FASI: "/v1/Campionati/FasiCampionato/list",
      CAMPIONATI_FASI_INCONTRI: "/v1/Campionati/IncontriFaseCampionato/list",
      CAMPIONATI_ISCRITTI_FASE: "/v1/Campionati/IscrittiFase/list",
      CAMPIONATI_ISCRIZIONE_SQUADRA: "/v1/Campionati/RichiesteIscrizioneSquadra/list",
      CAMPIONATO_ALLEGA_FORMAZIONE: "/v1/Campionati/FormazioneSquadra/list",
      TORNEI: "/v1/Tornei/Tornei/list",
      TORNEI_GARE: "/v1/Tornei/Gare/list",
      TORNEI_LOGS: "/v1/Tornei/Logs/list",
      GIUSTIFICATI_GIOCATORI_ASSENTI: "/v1/Tornei/InfoGiustificativiAssenzeTornei/list",
      TORNEI_GARE_DELETE: "v1/Tornei/Gare/delete",
      TIPOLOGIE_TORNEI: "v1/Lookup/TipologieTornei/list",
      CIRCOLI: "/v1/Backoffice/Circoli/list",
      CIRCUITI: "/v1/Backoffice/Circuiti/list",
      CATEGORIE_CLASSIFICA: "/v1/Backoffice/CategorieClassifica/list",
      TIPI_TORNEI: "/v1/Lookup/TipizzazioneTornei/list",
      STRUTTURA_TABELLONE: "/v1/Backoffice/StruttureTabellone/list",
      TIPOLOGIE_GARA_TORNEI: "/v1/Lookup/TipologieGaraTornei/list",
      TIPOLOGIE_GARA_A_SQUADRE: "/v1/Lookup/TipologieGaraASquadre/list",
      TIPOLOGIE_INCONTRI: "/v1/Lookup/TipologieIncontri/list",
      QUOTE_TORNEI_STANDARD: "/v1/Backoffice/QuoteTorneiStandard/list",
      QUOTE_PARTECIPAZIONE: "/v1/Tornei/GestioneQuote/partecipazioneList",
      PALLE: "/v1/Backoffice/Palle/list",
      SUPERFICI: "/v1/Backoffice/Superfici/list",
      IMPIANTI: "/v1/Backoffice/Impianti/list",
      DISCIPLINE: "/v1/Lookup/Discipline/list",
      CIRCOLI_EXTERNAL: "/v1/External/Circoli/list",
      AREE_REGIONALI: "/v1/Backoffice/AreeRegionaliGareASquadre/list",
      REGIONI: "/v1/Backoffice/Regioni/list",
      CONFIGURAZIONE_TORNEI_INTERNAZIONALI: "/v1/Backoffice/ConfigurazioniTorneiInternazionali/list",
      CONFIGURAZIONE_VITTORIE_INTERNAZIONALI: "/v1/Backoffice/ConfigurazioneVittorieInternazionali/list",
      MASSIMALI_CIRCOLI: "/v1/Backoffice/MassimaliCircoli/list",
      SERIE_GARE_A_SQUADRE: "/v1/Backoffice/SerieGareASquadre/list",
      STAGIONI_SPORTIVE: "/v1/Backoffice/StagioniSportive/list",
      TESSERATI_EQUIPARATI: "/v1/Backoffice/TesseratiEquiparati/list",
      CATEGORIE_ETA: "/v1/Backoffice/CategorieEta/list",
      CAUSALI: "/v1/Backoffice/CausaliCompetizioni/list",
      QUALIFICHE_ALBO_NAZIONALE: "/v1/Backoffice/QualificheAlboNazionale/list",
      ACQUISIZIONE_PUNTI: "/v1/Backoffice/AcquisizioniPuntiCalcoliClassifiche/list",
      ARMONIZZAZIONE: "/v1/Backoffice/ArmonizzazioniCalcoliClassifiche/list",
      BONUS_CAMPIONATI: "/v1/Backoffice/BonusCampionatiCalcoliClassifiche/list",
      BONUS_MANCANZE_SCONFITTE_ASSENZE: "/v1/Backoffice/BonusMancanzeSconfitteAssenzeCalcoliClassifiche/list",
      BONUS_VITTORIE_TORNEI: "/v1/Backoffice/BonusVittorieTorneiCalcoliClassifiche/list",
      CATEGORIE_CLASSIFICHE_FEDERAZIONI_ESTERE: "/v1/Backoffice/CategorieClassificheFederazioniEstereCalcoliClassifiche/list",
      QUALIFICHE_NAZIONALI: "/v1/Backoffice/ClassificheQualificheNazionaliCalcoliClassifiche/list",
      NUMERI_BASE_VITTORIE: "/v1/Backoffice/NumeriBaseVittorieCalcoliClassifiche/list",
      PRECEDENTI_CLASSIFICHE_FEDERALI: "/v1/Backoffice/PrecedentiClassificheFederaliCalcoliClassifiche/list",
      PROMOZIONI_RETROCESSIONI: "/v1/Backoffice/PromozioniRetrocessioniCalcoliClassifiche/list",
      PUNTI_DECURTAZIONI_ARMONIZZAZIONI: "/v1/Backoffice/PuntiDecurtazioniArmonizzazioniCalcoliClassifiche/list",
      VALUTAZIONI_CLASSIFICHE_INTERNAZIONALI: "/v1/Backoffice/ValutazioniClassificheTorneiInternazionaliCalcoliClassifiche/list",
      VITTORIE_SUPPLEMENTARI: "/v1/Backoffice/VittorieSupplementariCalcoliClassifiche/list",
      SEZIONI: "/v1/Tornei/SezioniGare/list",
      SEZIONI_DELETE: "/v1/Tornei/SezioniGare/delete",
      ISCRITTI_GARE: "/v1/Tornei/IscrittiGare/list",
      ISCRITTI_SEZIONI: "/v1/Tornei/IscrittiSezioniGare/list",
      ISCRITTI_SEZIONI_EXTENDED: "/v1/Tornei/IscrittiSezioniGare/extendedList",
      DISISCRITTI_GARE: "/v1/Tornei/DisiscrittiGara/list",
      TESSERATI: "/v1/External/Tesserati/list",
      REPORT_ISCRIZIONI_GIOCATORI: "/v1/Report/IscrizioniGiocatori/list",
      GIUDICI_ARBITRI: "/v1/External/GiudiciArbitri/list",
      PARTITE_GARE: "/v1/Tornei/PartiteGara/list",
      GESTIONE_PARTITE_GARE: "/v1/Tornei/GestioneOrariDiGioco/listPartite",
      LOOKUP_TIPOLOGIE_SELEZIONI: "/v1/Lookup/TipologieSezioni/list",
      LOOKUP_TIPOLOGIE_SELEZIONI_GARA: "/v1/Lookup/TipologiaSezioniGara/list",
      LOOKUP_GARE_A_SQUADRE_FASI: "/v1/Lookup/TipologiaGaraASquadreFase/list",
      LOOKUP_GARE_A_SQUADRE_TIPO_FASE: "/v1/Lookup/TipologiaGaraASquadreTipoFase/list",
      ISCRITTI_EQIPARATI_OPTIONS: "/v1/Backoffice/TesseratiEquiparati/list",
      STORICO_QUOTE: "/v1/Tornei/MovimentiContabili/storico/list",
      ODG: "/v1/Tornei/GestioneOrariDiGioco/listOrari",
      SEZIONI_EXTENDED: "/v1/Tornei/GestioneSezioniGare/extendedList",
      GIOCATORI_SQUADRA_CAMPIONATI: "/v1/Campionati/GiocatoriSquadra/list",
      ISCRITTI_GARE_EXTENDED: "/v1/Tornei/IscrittiSezioniGare/extendedList",
      PARTITE_DOPPIO_GIRNONI: "/v1/Tornei/PartiteDoppiGironi/list",
      PARTITE_SINGOLO_GIRONI: "/v1/Tornei/PartiteSingolariGironi/list",
      COMITATI_REGIONALI: "/v1/Backoffice/ComitatiRegionali/list",
      EDIT_GIRONI: "/v1/Tornei/GestioneGironiSezioni/list",
      QUOTE: "/v1/Backoffice/Quote/list",
      QUOTE_GARE_A_SQUADRE: "/v1/Backoffice/QuoteGareASquadre/list",
    },
    ADD: {
      // TODO Attività Internazionali: endpoint placeholder, non ancora disponibili lato backend (vedi fakeApi.ts).
      GARA_MANIFESTAZIONE: "/v1/Manifestazioni/Gare/add",
      ATTIVITA_INTERNAZIONALI: "/v1/AttivitaInternazionali/AttivitaInternazionali/add",
      ATTIVITA_INTERNAZIONALI_MASSIVA: "/v1/AttivitaInternazionali/AttivitaInternazionali/addMassivo",
      HELP_DESK:"/v1/HelpDesk/Richieste/add",
      MANIFESTAZIONI:"/v1/Manifestazioni/Manifestazioni/add",
      DETTAGLIO_INCONTRO: "/v1/Campionati/IncontriDettaglio/add",
      PARTITE_INCONTRI: "/v1/Campionati/PartiteIncontri/add",
      GIOCATORI_SQUADRA_CAMPIONATI: "/v1/Campionati/GiocatoriSquadra/add",
      GIOCATORI_INCONTRO_CAMPIONATI: "/v1/Campionati/GiocatoriIncontro/add",
      SQUADRE: "/v1/Campionati/RichiesteIscrizioneSquadra/add",
      UFFICIALI_ASSISTENTI: "/v1/Tornei/UfficialiDiGaraAssistenti/add",
      ODG_PARTITE: "/v1/Tornei/PartiteOrarioDiGioco/add",
      ODG: "/v1/Tornei/OrariDiGioco/add",
      ODG_SHEETS: "v1/Tornei/SheetOrariDiGioco/add",
      ODG_GIORNATA: "/v1/Tornei/GiornateOrarioDiGioco/add",
      CAMPIONATI: "/v1/Campionati/Campionati/add",
      CAMPIONATI_FASI: "/v1/Campionati/FasiCampionato/add",
      CAMPIONATO_ALLEGA_FORMAZIONE: "/v1/Campionati/FormazioneSquadra/add",
      CIRCOLI: "/v1/Backoffice/Circoli/add",
      CIRCUITI: "/v1/Backoffice/Circuiti/add",
      PALLE: "/v1/Backoffice/Palle/add",
      SUPERFICI: "/v1/Backoffice/Superfici/add",
      AREE_REGIONALI: "/v1/Backoffice/AreeRegionaliGareASquadre/add",
      CONFIGURAZIONE_TORNEI_INTERNAZIONALI: "/v1/Backoffice/ConfigurazioniTorneiInternazionali/add",
      CONFIGURAZIONE_VITTORIE_INTERNAZIONALI: "/v1/Backoffice/ConfigurazioneVittorieInternazionali/add",
      CATEGORIE_CLASSIFICA: "/v1/Backoffice/CategorieClassifica/add",
      MASSIMALI_CIRCOLI: "/v1/Backoffice/MassimaliCircoli/add",
      SERIE_GARE_A_SQUADRE: "/v1/Backoffice/SerieGareASquadre/add",
      STAGIONI_SPORTIVE: "/v1/Backoffice/StagioniSportive/add",
      TIPOLOGIE_TORNEI: "/v1/Lookup/TipologieTornei/add",
      TIPOLOGIE_INCONTRI: "/v1/Lookup/TipologieIncontri/add",
      TESSERATI_EQUIPARATI: "/v1/Backoffice/TesseratiEquiparati/add",
      CATEGORIE_ETA: "/v1/Backoffice/CategorieEta/add",
      CAUSALI: "/v1/Backoffice/CausaliCompetizioni/add",
      QUALIFICHE_ALBO_NAZIONALE: "/v1/Backoffice/QualificheAlboNazionale/add",
      ACQUISIZIONE_PUNTI: "/v1/Backoffice/AcquisizioniPuntiCalcoliClassifiche/add",
      ARMONIZZAZIONE: "/v1/Backoffice/ArmonizzazioniCalcoliClassifiche/add",
      BONUS_CAMPIONATI: "/v1/Backoffice/BonusCampionatiCalcoliClassifiche/add",
      BONUS_MANCANZE_SCONFITTE_ASSENZE: "/v1/Backoffice/BonusMancanzeSconfitteAssenzeCalcoliClassifiche/add",
      BONUS_VITTORIE_TORNEI: "/v1/Backoffice/BonusVittorieTorneiCalcoliClassifiche/add",
      CATEGORIE_CLASSIFICHE_FEDERAZIONI_ESTERE: "/v1/Backoffice/CategorieClassificheFederazioniEstereCalcoliClassifiche/add",
      QUALIFICHE_NAZIONALI: "/v1/Backoffice/ClassificheQualificheNazionaliCalcoliClassifiche/add",
      NUMERI_BASE_VITTORIE: "/v1/Backoffice/NumeriBaseVittorieCalcoliClassifiche/add",
      PRECEDENTI_CLASSIFICHE_FEDERALI: "/v1/Backoffice/PrecedentiClassificheFederaliCalcoliClassifiche/add",
      PROMOZIONI_RETROCESSIONI: "/v1/Backoffice/PromozioniRetrocessioniCalcoliClassifiche/add",
      PUNTI_DECURTAZIONI_ARMONIZZAZIONI: "/v1/Backoffice/PuntiDecurtazioniArmonizzazioniCalcoliClassifiche/add",
      VALUTAZIONI_CLASSIFICHE_INTERNAZIONALI: "/v1/Backoffice/ValutazioniClassificheTorneiInternazionaliCalcoliClassifiche/add",
      VITTORIE_SUPPLEMENTARI: "/v1/Backoffice/VittorieSupplementariCalcoliClassifiche/add",
      SEZIONI: "/v1/Tornei/SezioniGare/add",
      ISCRIVI_A_SEZIONE: "/v1/Tornei/GestioneSezioniGara/Iscrizione/add",
      ISCRIVI_A_GARA: "/v1/Tornei/GestioneGare/Iscrizione/add",
      GIUSTIFICATI_GIOCATORI_ASSENTI: "/v1/Tornei/GiustificativiAssenzeTornei/add",
      BULK_ISCRITTI: "/v1/Tornei/GestioneGare/Iscrizione/bulkAdd",
      ASSEGNA_DIRETTORE_GARA: "/v1/Tornei/GestioneTornei/direttoreGara",
      ASSEGNA_UFFICIALE_GARA: "/v1/Tornei/GestioneTornei/ufficialeGara",
      GIRONI: "/v1/Tornei/GestioneGironiSezioni/bulkAddSingoli",
      GIRONI_DOPPI: "/v1/Tornei/GestioneGironiSezioni/bulkAddDoppi",
    },
    EDIT: {
      GARA_MANIFESTAZIONE: "/v1/Manifestazioni/Gare/update",
      CAPITANO_INCONTRI: "/v1/Campionati/IncontriFaseCampionato/UpdateCapitanoSquadra",
      MANIFESTAZIONI:"/v1/Manifestazioni/Manifestazioni/update",
      STATO_ISCRIZIONE_CAMPIONATO: "/v1/Campionati/RichiesteIscrizioneSquadra/updateStato",
      INCONTRO: "/v1/Campionati/IncontriFaseCampionato/update",
      DETTAGLIO_INCONTRO: "/v1/Campionati/IncontriDettaglio/update",
      PARTITE_INCONTRI: "/v1/Campionati/PartiteIncontri/update",
      SQUADRE: "/v1/Campionati/RichiesteIscrizioneSquadra/update",
      ODG_GIORNATA: "/v1/Tornei/GiornateOrarioDiGioco/update",
      ODG: "/v1/Tornei/OrariDiGioco/update",
      ODG_SHEETS: "v1/Tornei/SheetOrariDiGioco/update",
      ODG_PARTITE: "/v1/Tornei/PartiteOrarioDiGioco/update",
      CAMPIONATI: "/v1/Campionati/Campionati/update",
      CAMPIONATI_FASI: "/v1/Campionati/FasiCampionato/update",
      CIRCOLI: "/v1/Backoffice/Circoli/update",
      CIRCUITI: "/v1/Backoffice/Circuiti/update",
      PALLE: "/v1/Backoffice/Palle/update",
      SUPERFICI: "/v1/Backoffice/Superfici/update",
      AREE_REGIONALI: "/v1/Backoffice/AreeRegionaliGareASquadre/update",
      CONFIGURAZIONE_TORNEI_INTERNAZIONALI: "/v1/Backoffice/ConfigurazioniTorneiInternazionali/update",
      CONFIGURAZIONE_VITTORIE_INTERNAZIONALI: "/v1/Backoffice/ConfigurazioneVittorieInternazionali/update",
      CATEGORIE_CLASSIFICA: "/v1/Backoffice/CategorieClassifica/update",
      MASSIMALI_CIRCOLI: "/v1/Backoffice/MassimaliCircoli/update",
      SERIE_GARE_A_SQUADRE: "/v1/Backoffice/SerieGareASquadre/update",
      STAGIONI_SPORTIVE: "/v1/Backoffice/StagioniSportive/update",
      TIPOLOGIE_TORNEI: "/v1/Lookup/TipologieTornei/update",
      TIPOLOGIE_INCONTRI: "/v1/Lookup/TipologieIncontri/update",
      TESSERATI_EQUIPARATI: "/v1/Backoffice/TesseratiEquiparati/update",
      CATEGORIE_ETA: "/v1/Backoffice/CategorieEta/update",
      CAUSALI: "/v1/Backoffice/CausaliCompetizioni/update",
      QUALIFICHE_ALBO_NAZIONALE: "/v1/Backoffice/QualificheAlboNazionale/update",
      ACQUISIZIONE_PUNTI: "/v1/Backoffice/AcquisizioniPuntiCalcoliClassifiche/update",
      ARMONIZZAZIONE: "/v1/Backoffice/ArmonizzazioniCalcoliClassifiche/update",
      BONUS_CAMPIONATI: "/v1/Backoffice/BonusCampionatiCalcoliClassifiche/update",
      BONUS_MANCANZE_SCONFITTE_ASSENZE: "/v1/Backoffice/BonusMancanzeSconfitteAssenzeCalcoliClassifiche/update",
      BONUS_VITTORIE_TORNEI: "/v1/Backoffice/BonusVittorieTorneiCalcoliClassifiche/update",
      CATEGORIE_CLASSIFICHE_FEDERAZIONI_ESTERE: "/v1/Backoffice/CategorieClassificheFederazioniEstereCalcoliClassifiche/update",
      QUALIFICHE_NAZIONALI: "/v1/Backoffice/ClassificheQualificheNazionaliCalcoliClassifiche/update",
      NUMERI_BASE_VITTORIE: "/v1/Backoffice/NumeriBaseVittorieCalcoliClassifiche/update",
      PRECEDENTI_CLASSIFICHE_FEDERALI: "/v1/Backoffice/PrecedentiClassificheFederaliCalcoliClassifiche/update",
      PROMOZIONI_RETROCESSIONI: "/v1/Backoffice/PromozioniRetrocessioniCalcoliClassifiche/update",
      PUNTI_DECURTAZIONI_ARMONIZZAZIONI: "/v1/Backoffice/PuntiDecurtazioniArmonizzazioniCalcoliClassifiche/update",
      VALUTAZIONI_CLASSIFICHE_INTERNAZIONALI: "/v1/Backoffice/ValutazioniClassificheTorneiInternazionaliCalcoliClassifiche/update",
      VITTORIE_SUPPLEMENTARI: "/v1/Backoffice/VittorieSupplementariCalcoliClassifiche/update",
      SEZIONI: "/v1/Tornei/SezioniGare/update",
      ISCRITTI_GARE: "/v1/Tornei/IscrittiGare/update",
      ISCRITTI_GARE_SPECIAL_ENTRY: "/v1/Tornei/IscrittiGare/setSpecialEntry",
      CONFERMA_GIRONI: "/v1/Tornei/GestioneSezioniGare/confermaGironi",
    },
    DELETE: {
      GIRONI: "v1/Tornei/GestioneSezioniGara/rimuoviGironiSezione",
    },
    UPLOAD: {
      UPLOAD_DOCUMENTI_TORNEO: "/v1/Tornei/DocumentiTorneo/upload",
      UPLOAD_ORARIO_DI_GIOCO: "/v1/Tornei/GestioneOrariDiGioco/uploadOrario",
    },
    OTHER: {
      GESTIONE_TIPIZZAZIONE:"v1/Tornei/GestioneTornei/tipizzazione",
      DESIDERATA_VISUALIZZATA:"/v1/Tornei/IscrittiGare/desiderataVisualizzata",
      BULK_ADD_PARTITE_GARA_MANIFESTAZIONI: "/v1/Manifestazioni/Partite/bulkAdd",
      BULK_UPDATE_PARTITE_GARA_MANIFESTAZIONI: "/v1/Manifestazioni/Partite/bulkUpdate",
      UPDATE_SEZIONI_CALCOLO_CLASS: "/v1/Tornei/GestioneSezioniGare/updateAbilitaPerClassifiche",
      UPLOAD_GARE_MANIFESTAZIONI:"/v1/Manifestazioni/GestioneGare/preload",
      ADD_REFERTO:"/v1/Tornei/TorneiReferto/chiusuraRefertoAdd",
      DOWNLOAD_REFERTO:"/v1/Pdf/refertoIncontro",
      CONFIRM_READ_MESSAGE: "/v1/Comunicazioni/Comunicazioni/confirmGaRead",
      GET_MESSAGES: "/v1/Comunicazioni/Comunicazioni/getMessages",
      SEND_MESSAGE: "/v1/Comunicazioni/Comunicazioni/sendMessage",
      MODIFICA_PARTITE_INCONTRO: "/v1/Campionati/PartiteIncontri/bulkUpsert",
      DELETE_DOCUMENTO_TORNEO: "/v1/Tornei/DocumentiTorneo/delete",
      ADD_REFERTO_INCONTRO: "/v1/Campionati/IncontriReferti/add",
      RIEPILOGO_REFERTO_INCONTRO: "/v1/Campionati/IncontriReferti/riepilogo",
      DETTAGLIO_INCONTRO: "/v1/Campionati/IncontriDettaglio/view",
      CHECK_CAPITANO_QUALIFICA: "/v1/External/Abilitato/Trasferta/check",
      CONFERMA_TABELLONE_FASE: "v1/Campionati/FasiCampionato/conferma",
      UPSERT_TABELLONE_CAMPIONATI: "v1/Campionati/IncontriFaseCampionato/bulkUpsert",
      CONFERMA_CAMPIONATO: "/v1/Campionati/GestioneCampionati/approva",
      RIMUOVI_CONFERMA_CAMPIONATO: "/v1/Campionati/GestioneCampionati/compilazione",
      ELIMINA_CAMPIONATO: "/v1/Campionati/GestioneCampionati/elimina",
      ISCRIZIONE_CAMPIONATO_DA_ALTRE_GARE: "/v1/Campionati/RichiesteIscrizioneSquadra/daAltroCampionato",
      EXPORT_TABELLONE: "/v1/Excel/Tornei/torneiTabellone",
      EXPORT_GIRONI: "/v1/Excel/Tornei/gironi",
      SWAP_GIOCATORI: "/v1/Tornei/GestionePartiteGara/swapIscritti",
      CONFERMA_TABELLONE: "/v1/Tornei/GestioneSezioniGare/confermaTabellone",
      ANNULLA_CONFERMA_TABELLONE: "v1/Tornei/GestioneSezioniGare/annullaConfermaTabellone",
      QUALIFICANTI_ENTRANTI: "/v1/Tornei/GestioneSezioniGare/qualificatiEntranti",
      UPSERT_TABELLONE: "/v1/Tornei/GestionePartiteGara/formattedUpsert",
      AZZERA_TABELLONE: "/v1/Tornei/GestionePartiteGara/bulkDelete",
      RISULTATO_UPSERT: "/v1/Tornei/GestionePartiteGara/risultatoUpsert",
      RISULTATO_SINGOLI_UPSERT: "/v1/Tornei/GestioneRisultatiSingolari/upsert",
      RISULTATO_DOPPI_UPSERT: "/v1/Tornei/GestioneRisultatiDoppi/upsert",
      NON_ISCRITTI_SEZIONI: "/v1/Tornei/GestioneIscrittiGare/nonIscrittiSezioni",
      TESSERATI_VIEW: "/v1/External/Tesserati/view",
      GESTIONE_PARTITE_GARA: "/v1/Tornei/GestionePartiteGara/bulkUpdate",
      ORARIO_DI_GIOCO_STAMPA: "/v1/Pdf/orarioDiGioco",
      ORARIO_DI_GIOCO_PUBBLICA: "/v1/Tornei/GestioneOrariDiGioco/pubblicaOrario",
      ORARIO_DI_GIOCO_CONTROLLO_PARTITE: "/v1/Tornei/GestioneOrariDiGioco/controlloPartite",
      ODG_CAMPI_BULK: "/v1/Tornei/CampiOrariDiGioco/fullBulkUpsert",
      ODG_SHEET_BULK: "/v1/Tornei/SheetOrariDiGioco/fullBulkUpsert",
      CREATE_TORNEO: "/v1/Tornei/GestioneTornei/upsert",
      GENERA_TABELLONE: "/v1/Tornei/GestionePartiteGara/generaTabellone",
      GENERA_TABELLONE_RAPIDO: "/v1/Tornei/GestionePartiteGara/generaTabelloneRapido",
      LOGS: "/v1/Tornei/Logs/list",
      RESET_REFERTO_TORNEI: "v1/Tornei/TorneiReferto/chiusuraRefertoReset",
      RESET_REFERTO_CAMPIONATI: "/v1/Campionati/IncontriReferti/reset",
      RIEPILOGO_CHIUSURA: "/v1/Tornei/GestioneTornei/chiusuraRiepilogo",
      CHIUSURA_TORNEO: "/v1/Tornei/GestioneTornei/chiusura",
      ODG: "/v1/Tornei/OrariDiGioco/list",
      ODG_SHEET: "/v1/Tornei/SheetOrariDiGioco/list",
      ODG_GIORNATE: "/v1/Tornei/GiornateOrarioDiGioco/list",
      ODG_PARTITE: "/v1/Tornei/PartiteOrarioDiGioco/list",
      APPROVA_TORNEO: "/v1/Tornei/GestioneTornei/approva",
      RIEPILOGO_MOVIMENTI: "/v1/Tornei/GestioneMoviementiContabili/riepilogo",
      REGOLAMENTO_PDF: "/v1/Pdf/regolamento",
      CAMPIONATI_FASI_GENERA_GIRONI: "/v1/Campionati/GestioneFasi/generaGironi",
      CAMPIONATI_FASI_INCONTRI_SALVA: "/v1/Campionati/IncontriFaseCampionato/bulkUpdate",
      VARIAZIONE_QUOTE: "/v1/Tornei/MovimentiContabili/variazione",
      RICERCA_MULTIPLA_TESSERATI: "/v1/External/Tesserati/multipla",
      RICHIEDI_APPROVAZIONE_TORNEO: "/v1/Tornei/GestioneTornei/richiestaApprovazione",
      ANNULLA_TORNEO: "/v1/Tornei/GestioneTornei/annulla",
      ANNULLA_BOZZA_TORNEO: "/v1/Tornei/Bozze/annulla",
      RIFIUTA_TORNEO: "/v1/Tornei/GestioneTornei/rifiuta",
      RIAPRI_TORNEO: "/v1/Tornei/GestioneTornei/riapri",
      CHIUDI_TORNEO: "/v1/Tornei/GestioneTornei/chiusura",
      AUTORIZZA_TORNEO: "/v1/Tornei/GestioneTornei/autorizza",
      ISCRIZIONE_MASSIVA_GIOCATORI: "/v1/Tornei/GestioneGare/Iscrizione/bulkAdd",
      ISCRIZIONE_MASSIVA_GIOCATORI_CAMPIONATO: "/v1/Campionati/RichiesteIscrizioneSquadra/bulkAdd",
      ELIMINAZIONE_MASSIVA_GIOCATORI: "/v1/Tornei/GestioneGare/Iscrizione/bulkRemove",
      RICERCA_MULTIPLA_SET_EQUIPARATO: "/v1/Tornei/GestioneTornei/equiparatoIscrizioneMultipla",
      UPSERT_GARE: "/v1/Tornei/GestioneGare/upsert",
      ISCRIVI_A_SEZIONE: "/v1/Tornei/GestioneSezioniGare/Iscrizione/bulkFullUpdate",
      DOWNLOAD_ISCRITTI_GARA: "/v1/Excel/Tornei/iscrittiGara",
      DOWNLOAD_VERBALE_DI_GARA: "/v1/Pdf/verbaleDiGara",
      DOWNLOAD_ISCRITTI_PAGANTI_XLSX: "/v1/Excel/Tornei/iscrittiPaganti",
      DOWNLOAD_ISCRITTI_PAGANTI_CSV: "/v1/Excel/Tornei/iscrittiPagantiCsv",
      DOWNLOAD_REFERTO_ARBITRALE: "/v1/Pdf/refertoArbitrale",
      DOWNLOAD_LISTA_TORNEI: "/v1/Excel/Tornei/listaTornei",
      DOWNLOAD_MODULO_ISCRIZIONE_SQUADRE_A_CAMPIONATO: "/v1/Pdf/moduloIscrizioneSquadreACampionato",
      DOWNLOAD_MODULO_ISCRIZIONE_UNICO: "/v1/Pdf/moduloIscrizioneUnicoSquadreACampionato",
      DOWNLOAD_DOCUMENTO_TABELLONE_FASI: "/v1/Excel/Campionati/tabelloneFase",
      DOWNLOAD_DOCUMENTO_GIRONE_FASI: "/v1/Excel/Campionati/gironeFase",
      DOWNLOAD_PUBBLICAZIONE_SQUADRE: "/v1/Excel/Campionati/pubblicazioneSquadraCampionato",
      RIAPERTURA_GARA: "/v1/Tornei/GestioneGare/riapri",
      CHIUSURA_GARA: "/v1/Tornei/GestioneGare/chiusura",
      RIMUOVI_AUTORIZZAZIONE: "/v1/Tornei/GestioneTornei/rimuoviAutorizzazione",
      AREE_REGIONALI_GARE_A_SQUADRE: "/v1/Backoffice/AreeRegionaliGareASquadre/update",
      ROLLBACK_REDAZIONE_RICHIESTA: "v1/Tornei/GestioneTornei/rollbackStatoRedazioneRichiesta",
      CONFERMA_FASI_CAMPIONATO: "/v1/Campionati/FasiCampionato/conferma",
      CONVALIDA_INCONTRO_CAMPIONATO: "/v1/Campionati/IncontriFaseCampionato/UpdateConvalidato",
      SQUADRA_ASSENTE_CAMPIONATO: "/v1/Campionati/IncontriFaseCampionato/UpdateSquadraAssente",
      CONVALIDA_SQUADRA_CAMPIONATO: "/v1/Campionati/IncontriFaseCampionato/UpdateSquadraConvalidata",
    },
  },
  GET: {
    VIEW: {
      USERNAME: "/v1/Sistema/Utente/username",
      HD_SETTORI:"/v1/Lookup/HelpDesk/settori",
      HD_TIPOLOGIE:"/v1/Lookup/HelpDesk/tipologie",
      MANIFESTAZIONI_GARE:"/v1/Manifestazioni/Gare/view",
      MANIFESTAZIONI:"/v1/Manifestazioni/Manifestazioni/view",
      MENU: "/v1/Sistema/Menu/view",
      INCONTRI_FASE_CAMPIONATO: "/v1/Campionati/IncontriFaseCampionato/view",
      RICHIESTE_ISCRIZIONE_SQUADRA: "/v1/Campionati/RichiesteIscrizioneSquadra/view",
      CAMPIONATI: "/v1/Campionati/Campionati/view",
      CAMPIONATI_FASI: "/v1/Campionati/FasiCampionato/view",
      CIRCUITI: "/v1/Backoffice/Circuiti/view",
      TORNEI: "/v1/Tornei/Tornei/view",
      PALLE: "/v1/Backoffice/Palle/view",
      SUPERFICI: "/v1/Backoffice/Superfici/view",
      CIRCOLI: "/v1/Backoffice/Circoli/view",
      CIRCOLI_EXTERNAL: "/v1/External/Circoli/view",
      CONFIGURAZIONE_TORNEI_INTERNAZIONALI: "/v1/Backoffice/ConfigurazioniTorneiInternazionali/view",
      CONFIGURAZIONE_VITTORIE_INTERNAZIONALI: "/v1/Backoffice/ConfigurazioneVittorieInternazionali/view",
      CATEGORIE_CLASSIFICA: "/v1/Backoffice/CategorieClassifica/view",
      MASSIMALI_CIRCOLI: "/v1/Backoffice/MassimaliCircoli/view",
      SERIE_GARE_A_SQUADRE: "/v1/Backoffice/SerieGareASquadre/view",
      STAGIONI_SPORTIVE: "/v1/Backoffice/StagioniSportive/view",
      TIPOLOGIE_TORNEI: "/v1/Lookup/TipologieTornei/view",
      TIPOLOGIE_INCONTRI: "/v1/Lookup/TipologieIncontri/view",
      TESSERATI_EQUIPARATI: "/v1/Backoffice/TesseratiEquiparati/view",
      CATEGORIE_ETA: "/v1/Backoffice/CategorieEta/view",
      CAUSALI: "/v1/Backoffice/CausaliCompetizioni/view",
      QUALIFICHE_ALBO_NAZIONALE: "/v1/Backoffice/QualificheAlboNazionale/view",
      ACQUISIZIONE_PUNTI: "/v1/Backoffice/AcquisizioniPuntiCalcoliClassifiche/view",
      ARMONIZZAZIONE: "/v1/Backoffice/ArmonizzazioniCalcoliClassifiche/view",
      BONUS_CAMPIONATI: "/v1/Backoffice/BonusCampionatiCalcoliClassifiche/view",
      BONUS_MANCANZE_SCONFITTE_ASSENZE: "/v1/Backoffice/BonusMancanzeSconfitteAssenzeCalcoliClassifiche/view",
      BONUS_VITTORIE_TORNEI: "/v1/Backoffice/BonusVittorieTorneiCalcoliClassifiche/view",
      CATEGORIE_CLASSIFICHE_FEDERAZIONI_ESTERE: "/v1/Backoffice/CategorieClassificheFederazioniEstereCalcoliClassifiche/view",
      QUALIFICHE_NAZIONALI: "/v1/Backoffice/ClassificheQualificheNazionaliCalcoliClassifiche/view",
      NUMERI_BASE_VITTORIE: "/v1/Backoffice/NumeriBaseVittorieCalcoliClassifiche/view",
      PRECEDENTI_CLASSIFICHE_FEDERALI: "/v1/Backoffice/PrecedentiClassificheFederaliCalcoliClassifiche/view",
      PROMOZIONI_RETROCESSIONI: "/v1/Backoffice/PromozioniRetrocessioniCalcoliClassifiche/view",
      PUNTI_DECURTAZIONI_ARMONIZZAZIONI: "/v1/Backoffice/PuntiDecurtazioniArmonizzazioniCalcoliClassifiche/view",
      VALUTAZIONI_CLASSIFICHE_INTERNAZIONALI: "/v1/Backoffice/ValutazioniClassificheTorneiInternazionaliCalcoliClassifiche/view",
      VITTORIE_SUPPLEMENTARI: "/v1/Backoffice/VittorieSupplementariCalcoliClassifiche/view",
      SEZIONI: "/v1/Tornei/SezioniGare/view",
      ISCRITTI_GARE: "/v1/Tornei/IscrittiGare/view",
      DOCUMENTI_TORNEO: "/v1/Tornei/DocumentiTorneoList/list",
      GARA: "/v1/Tornei/Gare/view",
      AREE_REGIONALI_GARE_SQUADRE: "/v1/Backoffice/AreeRegionaliGareASquadreComitatiRegionali/view",
      GIRONI_SEZIONI: "/v1/Tornei/GironiSezioni/view",
      PARTITA_DOPPIO: "/v1/Tornei/PartiteDoppiGironi/view",
      PARTITA_SINGOLO: "/v1/Tornei/PartiteSingolariGironi/view",
      RUOLI: "/v1/Sistema/Ruoli/view",
      CLASSIFICHE_RUN_DISPONIBILI: "/v1/Classifiche/RunDisponibili",
      CLASSIFICHE_DETTAGLIO_JSON: "/v1/Classifiche/DettaglioJson",
    },
  },
  EDIT: {},
  DELETE: {
    MANIFESTAZIONI_GARE_PARTITE_GESTIONE:"/v1/Manifestazioni/GestionePartite/delete",
    CAMPIONATO_ALLEGA_FORMAZIONE: "/v1/Campionati/FormazioneSquadra/delete",
    RIGA_ODG: "/v1/Tornei/OrariDiGioco/deleteRiga",
    MANIFESTAZIONI_GARE_PARTITE: "/v1/Manifestazioni/Partite/delete",
    MANIFESTAZIONI_GARE: "/v1/Manifestazioni/GestioneGare/delete",
    MANIFESTAZIONI: "/v1/Manifestazioni/GestioneManifestazioni/delete",
    DETTAGLIO_INCONTRO: "/v1/Campionati/IncontriDettaglio/delete",
    PARTITE_INCONTRI: "/v1/Campionati/PartiteIncontri/delete",
    GIOCATORI_SQUADRA_CAMPIONATI: "/v1/Campionati/GiocatoriSquadra/delete",
    ISCRIZIONE_SQUADRA: "/v1/Campionati/RichiesteIscrizioneSquadra/delete",
    UFFICIALI_ASSISTENTI: "/v1/Tornei/UfficialiDiGaraAssistenti/delete",
    ODG_SHEETS: "v1/Tornei/SheetOrariDiGioco/delete",
    ODG_GIORNATA: "/v1/Tornei/GiornateOrarioDiGioco/delete",
    ODG: "/v1/Tornei/PartiteOrarioDiGioco/delete",
    CAMPIONATI: "/v1/Campionati/Campionati/delete",
    CAMPIONATI_FASI: "/v1/Campionati/FasiCampionato/delete",
    SEZIONE: "/v1/Tornei/SezioniGare/delete",
    GARA: "/v1/Tornei/Gare/delete",
    ISCRITTI_GARA: "/v1/Tornei/GestioneGare/Iscrizione/delete",
    ORARIO_DI_GIOCO: "/v1/Tornei/GestioneOrariDiGioco/deleteOrario",
  },
} as const;
